import { constants } from '..';

const setClientGroupsLoadingAction = flag => ({
  type: constants.clientGroups.SET_CLIENT_GROUPS_LOADING,
  flag,
});

const getClientGroupsAction = params => ({
  type: constants.clientGroups.GET_CLIENT_GROUPS,
  params,
});

const setClientGroupsAction = (groups, total, header = {}) => ({
  type: constants.clientGroups.SET_CLIENT_GROUPS,
  groups,
  total,
  header,
});

const clearClientGroupsAction = () => ({
  type: constants.clientGroups.CLEAR_CLIENT_GROUPS,
});

const getClientGroupAction = id => ({
  type: constants.clientGroups.GET_CLIENT_GROUP,
  id,
});

const setClientGroupAction = group => ({
  type: constants.clientGroups.SET_CLIENT_GROUP,
  group,
});

const addClientGroupAction = (body, history) => ({
  type: constants.clientGroups.ADD_CLIENT_GROUP,
  body,
  history,
});

const editClientGroupAction = (id, body, history) => ({
  type: constants.clientGroups.EDIT_CLIENT_GROUP,
  id,
  body,
  history,
});

const deactivateClientGroupAction = (id, listParams, status = 0) => ({
  type: constants.clientGroups.DEACTIVATE_CLIENT_GROUP,
  id,
  listParams,
  status,
});

const syncClientGroupAction = (id, listParams) => ({
  type: constants.clientGroups.SYNC_CLIENT_GROUP,
  id,
  listParams,
});

const exportClientGroupsAction = (filename, filterBody) => ({
  type: constants.clientGroups.EXPORT_CLIENT_GROUPS,
  filename,
  filterBody,
});

export const clientGroupsActions = {
  setClientGroupsLoadingAction,
  getClientGroupsAction,
  setClientGroupsAction,
  clearClientGroupsAction,
  getClientGroupAction,
  setClientGroupAction,
  addClientGroupAction,
  editClientGroupAction,
  deactivateClientGroupAction,
  syncClientGroupAction,
  exportClientGroupsAction,
};
